import React from 'react'
import { NoResultsTitle } from './NoResults.components'
import { InsetTitle, NoResultsContainer, Note } from './NoResults.styles'

type NoResultsProps = {
  icons?: JSX.Element
  title: string
  largeTitle?: boolean
  note?: string
  buttons?: JSX.Element
  margin?: string
  // Set inside a panel rather than spanning an index page: rounded corners, a
  // lighter title, and the note tucked under it.
  inset?: boolean
}

export const NoResults = ({
  icons,
  title,
  note,
  buttons,
  largeTitle,
  margin,
  inset,
}: NoResultsProps): JSX.Element => {
  return (
    <NoResultsContainer margin={margin} $inset={inset}>
      {icons && icons}
      {inset ? (
        <InsetTitle>{title}</InsetTitle>
      ) : (
        <NoResultsTitle large={largeTitle ?? false}>{title}</NoResultsTitle>
      )}
      {note && <Note $inset={inset}>{note}</Note>}
      {buttons}
    </NoResultsContainer>
  )
}
